var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g3, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _g4, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _circle4, _circle5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsFeedEmptyGorilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 180,
    viewBox: "0 0 480 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7726_27477)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 2,
    r: 29,
    stroke: "#F68229",
    strokeOpacity: 0.3,
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 180,
    r: 85,
    stroke: "#65F624",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 26.5,
    r: 36.5,
    stroke: "#B175FD",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 181.303C347.063 181.303 433.855 178.015 433.855 173.96C433.855 169.904 347.063 166.617 240 166.617C132.937 166.617 46.1455 169.904 46.1455 173.96C46.1455 178.015 132.937 181.303 240 181.303Z",
    fill: "#024C88"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7726_27477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 11,
    width: 255,
    height: 165
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.441 11.6431H106.682V175.667H360.441V11.6431Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7726_27477)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.874 155.917C211.874 155.917 221.877 161.734 232.269 160.995",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.405 139.89C188.405 139.89 191.459 157.705 190.795 170.319",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.298 131.707C197.298 131.707 218.888 138.164 232.952 124.947",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.384 217.166C227.654 238.972 210.204 253.289 194.41 249.141C178.615 244.993 170.462 223.954 176.191 202.148C178.767 192.339 183.719 184.048 189.818 178.269C197.284 171.196 206.476 167.888 215.165 170.172C230.96 174.32 239.113 195.359 233.384 217.166Z",
    fill: "#4C4C4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.128 249.14C290.92 244.994 299.075 223.954 293.343 202.147C287.61 180.339 270.162 166.022 254.37 170.169C238.579 174.315 230.424 195.355 236.156 217.163C241.888 238.97 259.337 253.287 275.128 249.14Z",
    fill: "#4C4C4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.741 72.4028H196.487C193.344 72.4028 190.795 74.9497 190.795 78.0915V172.58C190.795 175.722 193.344 178.269 196.487 178.269H271.741C274.884 178.269 277.433 175.722 277.433 172.58V78.0915C277.433 74.9497 274.884 72.4028 271.741 72.4028Z",
    fill: "#4C4C4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.246 182.114C186.246 182.114 190.795 177.909 190.795 166.185C190.795 154.462 188.21 140.52 188.21 140.52C188.21 140.52 165.628 86.8709 171.254 78.7029C176.879 70.5397 187.726 75.3513 192.28 72.4738C196.833 69.5963 202.994 65.1828 206.609 49.2545C210.223 33.3262 219.396 21.5459 234.318 21.5459V202.067L186.246 182.114Z",
    fill: "#4C4C4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.393 182.114C282.393 182.114 277.845 177.909 277.845 166.185C277.845 154.462 280.43 140.52 280.43 140.52C280.43 140.52 303.012 86.8709 297.386 78.7029C291.761 70.5397 280.914 75.3513 276.36 72.4738C271.807 69.5963 265.646 65.1828 262.031 49.2545C258.417 33.3262 249.244 21.5459 234.322 21.5459V202.067L282.393 182.114Z",
    fill: "#4C4C4C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.814 133.333C272.193 133.333 284.661 125.582 284.661 116.021C284.661 106.459 272.193 98.708 256.814 98.708C241.435 98.708 228.967 106.459 228.967 116.021C228.967 125.582 241.435 133.333 256.814 133.333Z",
    fill: "#878787"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.089 133.333C224.469 133.333 236.936 125.582 236.936 116.021C236.936 106.459 224.469 98.708 209.089 98.708C193.71 98.708 181.243 106.459 181.243 116.021C181.243 125.582 193.71 133.333 209.089 133.333Z",
    fill: "#878787"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.564 161.009C249.132 161.009 261.752 154.699 261.752 146.915C261.752 139.131 249.132 132.821 233.564 132.821C217.996 132.821 205.375 139.131 205.375 146.915C205.375 154.699 217.996 161.009 233.564 161.009Z",
    fill: "#878787"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.82 205.219C253.519 205.219 268.677 195.185 268.677 182.806C268.677 170.427 253.519 160.393 234.82 160.393C216.122 160.393 200.964 170.427 200.964 182.806C200.964 195.185 216.122 205.219 234.82 205.219Z",
    fill: "#474747"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.005 126.896C235.005 126.896 253.968 139.069 271.138 130.252",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.047 161.886C198.047 161.886 193.053 178.814 198.047 191.585",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.634 69.9141H188.144C177.988 69.9141 169.755 78.1427 169.755 88.2932V184.053C169.755 194.203 177.988 202.432 188.144 202.432H280.634C290.79 202.432 299.023 194.203 299.023 184.053V88.2932C299.023 78.1427 290.79 69.9141 280.634 69.9141Z",
    fill: "#FFBB43"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7726_27477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 69,
    width: 131,
    height: 134
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M280.634 69.9141H188.144C177.988 69.9141 169.755 78.1427 169.755 88.2932V184.053C169.755 194.203 177.988 202.432 188.144 202.432H280.634C290.79 202.432 299.023 194.203 299.023 184.053V88.2932C299.023 78.1427 290.79 69.9141 280.634 69.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7726_27477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.479 69.9141H175.447C172.303 69.9141 169.755 72.461 169.755 75.6027V196.743C169.755 199.885 172.303 202.432 175.447 202.432H240.479C243.622 202.432 246.171 199.885 246.171 196.743V75.6027C246.171 72.461 243.622 69.9141 240.479 69.9141Z",
    fill: "#E0A648"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.025 69.9141H187.983C177.916 69.9141 169.755 78.0705 169.755 88.1321V184.214C169.755 194.275 177.916 202.432 187.983 202.432H224.025C234.092 202.432 242.253 194.275 242.253 184.214V88.1321C242.253 78.0705 234.092 69.9141 224.025 69.9141Z",
    fill: "#FFBB43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.018 112.764H169.522V153.533H299.018V112.764Z",
    fill: "#F7FFA3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M243.059 108.251H241.181V198.815H243.059V108.251Z",
    fill: "#4C330C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 147.901H169.522V153.533H299.023V147.901Z",
    fill: "#4C330C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.624 150.518C183.624 150.518 173.645 172.552 167.754 179.691C161.863 186.831 160.672 150.708 160.819 150.921C160.966 151.134 183.629 150.518 183.629 150.518H183.624Z",
    fill: "#4C4C4C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M284.893 150.518C284.893 150.518 294.873 172.552 300.764 179.691C306.655 186.831 307.845 150.708 307.698 150.921C307.551 151.134 284.889 150.518 284.889 150.518H284.893Z",
    fill: "#4C4C4C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M181.869 124.179C194.202 124.179 204.199 113.55 204.199 100.439C204.199 87.3269 194.202 76.6978 181.869 76.6978C169.536 76.6978 159.539 87.3269 159.539 100.439C159.539 113.55 169.536 124.179 181.869 124.179Z",
    fill: "#4C4C4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.647 146.883C193.635 130.751 190.653 112.995 178.987 107.225C167.321 101.455 151.389 109.855 143.401 125.987C135.413 142.119 138.395 159.875 150.061 165.645C161.727 171.416 177.659 163.015 185.647 146.883Z",
    fill: "#4C4C4C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M169.733 193.323C171.538 165.419 161.027 142.025 146.254 141.07C131.482 140.116 118.044 161.962 116.238 189.865C114.433 217.769 124.944 241.163 139.717 242.118C154.489 243.073 167.927 221.226 169.733 193.323Z",
    fill: "#4C4C4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.967 143.923C187.499 135.354 185.974 126.6 180.561 124.371C175.147 122.142 167.896 127.282 164.363 135.852C160.831 144.421 162.356 153.175 167.769 155.404C173.183 157.633 180.434 152.493 183.967 143.923Z",
    fill: "#565656"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.877 104.468C201.409 95.8982 198.596 86.614 191.594 83.7308C184.592 80.8477 176.052 85.4575 172.52 94.027C168.987 102.596 171.8 111.881 178.803 114.764C185.805 117.647 194.344 113.037 197.877 104.468Z",
    fill: "#565656"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M164.731 194.159C165.396 176.68 159.801 162.277 152.234 161.989C144.666 161.701 137.992 175.637 137.326 193.116C136.66 210.595 142.255 224.999 149.823 225.286C157.391 225.574 164.065 211.638 164.731 194.159Z",
    fill: "#565656"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M286.477 124.179C298.81 124.179 308.808 113.55 308.808 100.439C308.808 87.3269 298.81 76.6978 286.477 76.6978C274.145 76.6978 264.147 87.3269 264.147 100.439C264.147 113.55 274.145 124.179 286.477 124.179Z",
    fill: "#4C4C4C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M318.287 165.606C329.953 159.836 332.935 142.08 324.947 125.948C316.959 109.816 301.027 101.416 289.361 107.186C277.695 112.956 274.713 130.712 282.701 146.844C290.688 162.976 306.621 171.376 318.287 165.606Z",
    fill: "#4C4C4C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M328.635 242.104C343.407 241.15 353.919 217.755 352.114 189.852C350.308 161.948 336.869 140.102 322.097 141.057C307.325 142.012 296.814 165.406 298.619 193.309C300.424 221.213 313.863 243.059 328.635 242.104Z",
    fill: "#4C4C4C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M301.934 156.429C307.348 154.2 308.872 145.447 305.34 136.877C301.808 128.308 294.556 123.167 289.143 125.396C283.73 127.625 282.205 136.379 285.737 144.949C289.269 153.518 296.521 158.658 301.934 156.429Z",
    fill: "#565656"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M290.907 115.794C297.91 112.911 300.722 103.627 297.19 95.0572C293.658 86.4877 285.118 81.878 278.116 84.7611C271.114 87.6442 268.301 96.9284 271.833 105.498C275.365 114.067 283.905 118.677 290.907 115.794Z",
    fill: "#565656"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M319.862 226.342C327.429 226.054 333.024 211.651 332.359 194.172C331.693 176.693 325.018 162.757 317.451 163.045C309.883 163.333 304.288 177.736 304.954 195.215C305.62 212.694 312.294 226.63 319.862 226.342Z",
    fill: "#565656"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M234.522 72.4028C248.911 72.4028 260.575 65.4816 260.575 56.9438C260.575 48.4061 248.911 41.4849 234.522 41.4849C220.132 41.4849 208.468 48.4061 208.468 56.9438C208.468 65.4816 220.132 72.4028 234.522 72.4028Z",
    fill: "#4C4C4C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.062 59.689H211.579C208.436 59.689 205.888 62.2359 205.888 65.3776V79.5662C205.888 82.7079 208.436 85.2548 211.579 85.2548H258.062C261.205 85.2548 263.753 82.7079 263.753 79.5662V65.3776C263.753 62.2359 261.205 59.689 258.062 59.689Z",
    fill: "#4C4C4C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M234.522 110.569C246.352 110.569 255.942 97.3063 255.942 80.9456C255.942 64.5848 246.352 51.3218 234.522 51.3218C222.692 51.3218 213.102 64.5848 213.102 80.9456C213.102 97.3063 222.692 110.569 234.522 110.569Z",
    fill: "#4C4C4C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M234.318 69.6867C247.819 69.6867 258.764 58.909 258.764 45.6141C258.764 32.3192 247.819 21.5415 234.318 21.5415C220.817 21.5415 209.872 32.3192 209.872 45.6141C209.872 58.909 220.817 69.6867 234.318 69.6867Z",
    fill: "#4C4C4C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M262.985 75.9536L263.882 77.9636C263.882 77.9636 262.089 106.895 234.949 110.569L262.985 75.9584V75.9536Z",
    fill: "#4C4C4C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.846 76.0249L205.949 78.0349C205.949 78.0349 207.742 106.967 234.882 110.641L206.846 76.0296V76.0249Z",
    fill: "#4C4C4C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M216.356 61.3197C216.356 61.1395 215.113 54.4885 220.278 54.991C225.728 55.522 235.617 56.5838 235.617 56.5838C235.617 56.5838 249.7 54.7208 250.952 54.9626C252.204 55.2043 254.879 56.3231 252.783 60.8266C250.686 65.3302 216.223 67.3402 216.356 61.3197Z",
    fill: "#8E8E8E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M253.433 61.3197C253.433 61.1395 254.675 54.4885 249.51 54.991C244.06 55.522 234.171 56.5838 234.171 56.5838C234.171 56.5838 220.089 54.7208 218.837 54.9626C217.584 55.2043 214.909 56.3231 217.006 60.8266C219.102 65.3302 253.565 67.3402 253.433 61.3197Z",
    fill: "#8E8E8E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M247.139 60.4521H222.498C219.355 60.4521 216.807 62.9991 216.807 66.1408V66.2072C216.807 69.349 219.355 71.8959 222.498 71.8959H247.139C250.282 71.8959 252.83 69.349 252.83 66.2072V66.1408C252.83 62.9991 250.282 60.4521 247.139 60.4521Z",
    fill: "#383838"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.65 63.5712C222.65 63.5712 224.547 60.3476 227.848 60.5088",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M221.882 68.4399C221.882 68.4399 225.368 70.649 228.617 69.1842",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M221.654 69.9141C221.654 69.9141 225.14 72.1232 228.389 70.6583",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M219.956 70.9761C219.956 70.9761 222.949 73.8157 226.421 73.005",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M226.312 67.7618C227.349 67.7618 228.19 67.0487 228.19 66.169C228.19 65.2893 227.349 64.5762 226.312 64.5762C225.275 64.5762 224.434 65.2893 224.434 66.169C224.434 67.0487 225.275 67.7618 226.312 67.7618Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7726_27477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 64,
    width: 5,
    height: 4
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M226.312 67.7618C227.349 67.7618 228.19 67.0487 228.19 66.169C228.19 65.2893 227.349 64.5762 226.312 64.5762C225.275 64.5762 224.434 65.2893 224.434 66.169C224.434 67.0487 225.275 67.7618 226.312 67.7618Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7726_27477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.704 66.3114C225.11 66.3114 225.439 65.9824 225.439 65.5766C225.439 65.1708 225.11 64.8418 224.704 64.8418C224.298 64.8418 223.969 65.1708 223.969 65.5766C223.969 65.9824 224.298 66.3114 224.704 66.3114Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M226.312 67.7618C227.349 67.7618 228.19 67.0487 228.19 66.169C228.19 65.2893 227.349 64.5762 226.312 64.5762C225.275 64.5762 224.434 65.2893 224.434 66.169C224.434 67.0487 225.275 67.7618 226.312 67.7618Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M234.522 106.269C242.485 106.269 248.941 99.8173 248.941 91.8581C248.941 83.8989 242.485 77.4468 234.522 77.4468C226.559 77.4468 220.103 83.8989 220.103 91.8581C220.103 99.8173 226.559 106.269 234.522 106.269Z",
    fill: "#8E8E8E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M236.547 94.38C237.695 94.38 238.625 92.4465 238.625 90.0613C238.625 87.6762 237.695 85.7427 236.547 85.7427C235.4 85.7427 234.47 87.6762 234.47 90.0613C234.47 92.4465 235.4 94.38 236.547 94.38Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M233.36 91.019C233.809 92.9589 235.292 96.4507 237.629 94.8988",
    stroke: "black",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M239.213 73.811H230.808C227.664 73.811 225.116 76.3579 225.116 79.4997V79.5661C225.116 82.7079 227.664 85.2548 230.808 85.2548H239.213C242.356 85.2548 244.904 82.7079 244.904 79.5661V79.4997C244.904 76.3579 242.356 73.811 239.213 73.811Z",
    fill: "#8E8E8E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M231.667 77.4517H230.865C229.817 77.4517 228.968 78.3006 228.968 79.3479C228.968 80.3951 229.817 81.2441 230.865 81.2441H231.667C232.714 81.2441 233.564 80.3951 233.564 79.3479C233.564 78.3006 232.714 77.4517 231.667 77.4517Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M239.075 77.4517H238.274C237.226 77.4517 236.376 78.3006 236.376 79.3479C236.376 80.3951 237.226 81.2441 238.274 81.2441H239.075C240.123 81.2441 240.973 80.3951 240.973 79.3479C240.973 78.3006 240.123 77.4517 239.075 77.4517Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M246.38 63.41C246.38 63.41 243.657 60.3096 240.124 60.8026",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M247.49 68.4395C247.49 68.4395 244.003 70.6486 240.754 69.1837",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M247.717 69.9141C247.717 69.9141 244.231 72.1232 240.982 70.6583",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M249.415 70.9761C249.415 70.9761 246.422 73.8157 242.95 73.005",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M243.059 67.7618C244.097 67.7618 244.938 67.0487 244.938 66.169C244.938 65.2893 244.097 64.5762 243.059 64.5762C242.022 64.5762 241.181 65.2893 241.181 66.169C241.181 67.0487 242.022 67.7618 243.059 67.7618Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7726_27477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 64,
    width: 4,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M243.059 67.7618C244.097 67.7618 244.938 67.0487 244.938 66.169C244.938 65.2893 244.097 64.5762 243.059 64.5762C242.022 64.5762 241.181 65.2893 241.181 66.169C241.181 67.0487 242.022 67.7618 243.059 67.7618Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7726_27477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.667 66.3114C245.073 66.3114 245.403 65.9824 245.403 65.5766C245.403 65.1708 245.073 64.8418 244.667 64.8418C244.261 64.8418 243.932 65.1708 243.932 65.5766C243.932 65.9824 244.261 66.3114 244.667 66.3114Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M243.059 67.7618C244.097 67.7618 244.938 67.0487 244.938 66.169C244.938 65.2893 244.097 64.5762 243.059 64.5762C242.022 64.5762 241.181 65.2893 241.181 66.169C241.181 67.0487 242.022 67.7618 243.059 67.7618Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M248.585 54.986L236.263 56.4698C234.972 56.6262 233.663 56.6262 232.373 56.4698L219.956 54.986C219.956 54.986 215.711 54.6446 215.341 57.4842",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M220.207 51.8384H248.836",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M205.888 69.6865C205.888 69.6865 201.78 102.548 234.949 110.569",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M209.331 60.3193C209.331 60.3193 202.131 63.5524 207.083 71.8958",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M263.113 69.6865C263.113 69.6865 267.221 102.548 234.052 110.569",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M259.669 60.3193C259.669 60.3193 266.869 63.5524 261.918 71.8958",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M225.249 78.2764C225.249 78.2764 219.415 87.6816 220.107 92.1567",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.233 41.4849C210.233 41.4849 209.308 45.448 209.896 50.3876",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M167.753 85.2544C167.753 85.2544 154.359 93.4888 155.431 115.262C156.503 137.036 167.753 85.2544 167.753 85.2544Z",
    fill: "#4C4C4C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M300.769 85.2544C300.769 85.2544 314.163 93.4888 313.091 115.262C312.019 137.036 300.769 85.2544 300.769 85.2544Z",
    fill: "#4C4C4C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M169.523 81.2441C169.523 81.2441 154.719 92.4224 157.143 112.764",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M162.194 120.61C162.194 120.61 163.133 123.653 174.247 122.046",
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M151.043 115.049C151.043 115.049 142.487 123.354 139.755 136.419",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M183.624 122.51C183.624 122.51 189.306 123.226 202.335 109.938",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M189.837 124.179C189.837 124.179 192.171 138.481 181.248 155.604",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M168.266 170.319C168.266 170.319 174.854 203.987 160.312 227.31",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M132.489 147.901C132.489 147.901 142.568 137.173 155.374 136.638",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M299.018 81.2441C299.018 81.2441 313.821 92.4224 311.398 112.764",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M306.579 120.61C306.579 120.61 305.639 123.653 294.526 122.046",
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M317.146 115.049C317.146 115.049 325.703 123.354 328.435 136.419",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M285.149 122.51C285.149 122.51 279.467 123.226 266.438 109.938",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M278.941 124.179C278.941 124.179 276.607 138.481 287.53 155.604",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M300.508 170.319C300.508 170.319 293.92 203.987 308.462 227.31",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M338.267 149.011C338.267 149.011 328.188 138.283 315.382 137.747",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M219.628 40.1623C219.628 40.1623 225.723 37.0857 228.982 39.6029",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M225.628 34.1607C225.628 34.1607 233.127 36.9292 238.487 34.1607C243.847 31.3922 248.585 33.1794 248.585 33.1794",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M256.966 49.0415C256.966 49.0415 260.339 51.7199 260.571 56.7591",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M235.011 79.5328C235.011 79.5328 232.838 77.5228 232.037 77.4848C231.235 77.4469 231.268 77.5512 231.268 77.5512V81.2441L238.677 81.301V77.4517L237.785 77.518C237.785 77.518 236.879 77.7361 235.011 79.5328Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M159.908 148.882C159.908 148.882 165.287 157.074 165.78 161.009",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M230.775 70.1986C230.775 70.1986 234.973 67.8852 239.165 70.1986",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M230.775 68.7904C230.775 68.7904 234.973 66.477 239.165 68.7904",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M230.689 72.0047C230.689 72.0047 234.887 69.6913 239.08 72.0047",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M208.463 33.9997C208.463 23.7364 216.863 15.3408 227.132 15.3408H242.893C253.162 15.3408 261.562 23.7364 261.562 33.9997",
    fill: "#FFF57D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7726_27477",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 15,
    width: 54,
    height: 19
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M208.463 33.9997C208.463 23.7364 216.863 15.3408 227.132 15.3408H242.893C253.162 15.3408 261.562 23.7364 261.562 33.9997",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7726_27477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.031 14.5776H218.609V27.6047H225.031V14.5776Z",
    fill: "#DDCF4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.269 12.5913H227.645V34.981H244.269V12.5913Z",
    fill: "#DDCF4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.309 14.5776H246.887V27.6047H253.309V14.5776Z",
    fill: "#DDCF4E"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M208.463 33.9997C208.463 23.7364 216.863 15.3408 227.132 15.3408H242.893C253.162 15.3408 261.562 23.7364 261.562 33.9997",
    stroke: "#B7A60F",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M258.697 41.6985L235.006 39.2998L211.314 41.6985C208.411 41.6985 206.04 39.3235 206.04 36.427C206.04 33.5258 208.416 34.0425 211.314 34.0425H258.693C261.595 34.0425 263.967 33.5305 263.967 36.427C263.967 39.3282 261.591 41.6985 258.693 41.6985H258.697Z",
    fill: "#FFF57D",
    stroke: "#B7A60F",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M224.082 13.6294H217.66V26.6565H224.082V13.6294Z",
    fill: "#FFF57D",
    stroke: "#B7A60F",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M243.32 11.6431H226.696V34.0328H243.32V11.6431Z",
    fill: "#FFF57D",
    stroke: "#B7A60F",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M252.361 13.6294H245.938V26.6565H252.361V13.6294Z",
    fill: "#FFF57D",
    stroke: "#B7A60F",
    strokeMiterlimit: 10
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M190.636 50.9466L189.287 47.2205L191.244 46.3858C191.799 46.1301 192.217 45.8148 192.496 45.4399C192.775 45.065 192.821 44.5811 192.633 43.9883C192.486 43.5255 192.198 43.195 191.769 42.9968C191.34 42.7986 190.857 42.7843 190.322 42.9539C189.96 43.0685 189.681 43.2683 189.485 43.5533C189.299 43.8192 189.194 44.1151 189.17 44.441L185.38 44.6154C185.321 43.4247 185.624 42.3737 186.29 41.4624C186.957 40.5511 187.934 39.8914 189.221 39.4834C190.292 39.1441 191.308 39.0608 192.271 39.2333C193.233 39.4058 194.067 39.8019 194.773 40.4216C195.489 41.0223 196.005 41.8215 196.322 42.8192C196.551 43.5423 196.599 44.2434 196.464 44.9227C196.339 45.5829 196.047 46.1927 195.587 46.7521C195.137 47.2924 194.55 47.7491 193.824 48.1222L194.282 49.7913L190.636 50.9466ZM194.028 55.3145C193.42 55.507 192.823 55.4574 192.237 55.1657C191.661 54.855 191.277 54.3959 191.084 53.7886C190.891 53.1813 190.943 52.5919 191.24 52.0206C191.546 51.4302 192.003 51.0387 192.611 50.8462C193.218 50.6536 193.81 50.7127 194.386 51.0235C194.973 51.3152 195.362 51.7647 195.555 52.372C195.747 52.9794 195.69 53.5782 195.384 54.1686C195.088 54.74 194.636 55.1219 194.028 55.3145Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M273.077 43.5492L274.692 39.93L276.68 40.6851C277.258 40.8862 277.778 40.9486 278.239 40.872C278.7 40.7955 279.069 40.4785 279.345 39.9211C279.56 39.486 279.582 39.0484 279.411 38.6081C279.239 38.1678 278.902 37.8232 278.398 37.5743C278.058 37.406 277.719 37.3566 277.38 37.4258C277.061 37.4882 276.78 37.6284 276.536 37.8465L273.685 35.3446C274.469 34.4459 275.417 33.8993 276.529 33.7047C277.642 33.5102 278.803 33.7124 280.014 34.3112C281.021 34.8091 281.811 35.4538 282.384 36.2452C282.958 37.0366 283.284 37.9002 283.362 38.8361C283.461 39.7651 283.278 40.6987 282.814 41.6369C282.477 42.3167 282.024 42.8545 281.456 43.2503C280.908 43.6392 280.274 43.8759 279.555 43.9602C278.856 44.0377 278.116 43.9593 277.334 43.7251L276.505 45.2448L273.077 43.5492ZM272.489 49.0468C271.918 48.7642 271.522 48.3147 271.303 47.6982C271.103 47.0749 271.145 46.4777 271.428 45.9067C271.71 45.3357 272.157 44.9471 272.767 44.7411C273.397 44.5282 273.998 44.5631 274.569 44.8457C275.141 45.1283 275.526 45.5812 275.725 46.2045C275.945 46.821 275.914 47.4148 275.631 47.9858C275.348 48.5568 274.892 48.9488 274.261 49.1617C273.651 49.3677 273.06 49.3294 272.489 49.0468Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2528 60.3093C98.2528 49.8516 89.7722 41.3755 79.3089 41.3755C70.1453 41.3755 62.5042 47.8748 60.7445 56.5121C59.0939 56.0428 57.3532 55.7868 55.5508 55.7868C45.0876 55.7868 36.6069 64.2629 36.6069 74.7206C36.6069 80.6369 39.3247 85.9179 43.5793 89.3927C43.2615 90.7627 43.0907 92.1896 43.0907 93.6592C43.0907 104.117 51.5714 112.593 62.0346 112.593C69.4528 112.593 75.8654 108.331 78.9769 102.126C79.086 102.126 79.1998 102.135 79.3089 102.135C89.7722 102.135 98.2528 93.6592 98.2528 83.2015C98.2528 78.9018 96.8156 74.9387 94.3967 71.7578C96.8156 68.5769 98.2528 64.6137 98.2528 60.3141V60.3093Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M448.995 79.2434C448.995 68.7857 440.514 60.3096 430.051 60.3096C427.855 60.3096 425.754 60.6888 423.79 61.3714C420.474 55.8724 414.441 52.189 407.55 52.189C397.086 52.189 388.606 60.6651 388.606 71.1228C388.606 71.8434 388.648 72.5497 388.729 73.2466C382.653 76.399 378.503 82.7419 378.503 90.0566C378.503 100.514 386.984 108.99 397.447 108.99C399.709 108.99 401.877 108.592 403.888 107.867C407.227 110.801 411.6 112.584 416.395 112.584C425.526 112.584 433.148 106.127 434.941 97.5372C443.037 95.385 449.004 88.0087 449.004 79.2386L448.995 79.2434Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M115.484 175.667H360.441",
    stroke: "#1E96F2",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 62,
    r: 58,
    stroke: "#F5D517",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 132.5,
    r: 36.5,
    stroke: "#CF0937",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7726_27477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFeedEmptyGorilla);
export default __webpack_public_path__ + "static/media/NewsFeed-Empty-Gorilla.e416878a3d05a3f1af3eea0054f0e666.svg";
export { ForwardRef as ReactComponent };